/**
 * @description
 * Product functions
 */

import Plyr from 'plyr';
import SlickOptions from '../providers/slick';
import * as bodyScrollLock from 'body-scroll-lock';

const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const bodyElement = document.querySelector('.dd-m-modal');
const slickOptions = new SlickOptions();
const players = [];
let slider2 = null;

const resetSlider2 = () => {
    slider2.css('visibility', 'hidden');
    setTimeout(() => {
        slider2.slick('destroy');
    }, 300);
};

export default function initProduct() {

    // Slide principal
    const mainSlider = $('#featuredGallery').slick(slickOptions.getCustomGallery('.dd-carousel--featured-gallery-nav'));
    mainSlider.init(() => mainSlider.css('visibility', 'visible'));
    mainSlider.on('beforeChange', () => players.map(item => item.pause()));

    // Slide de thumbs
    const slider = $('#featuredGalleryNav').slick(slickOptions.getCustomGalleryNav('.dd-carousel--featured-gallery'));
    slider.init(() => slider.css('visibility', 'visible'));

    // Altera imagem da galeria clicando na thumb
    $(document).on('click', '.dd-carousel--custom-gallery .dd-m-carousel--custom-gallery__link', (e) => {
        const $el = $(e.target),
            imgDesktop = $el.data('desktop'),
            imgTablet = $el.data('tablet'),
            imgMobile = $el.data('mobile');

        $('#galleryModalFeaturedImage').parent().removeClass('dd-has-video');
        $('#dd-product-gallery .plyr--video').remove();

        if ($el.data('video')) {
            $('#galleryModalFeaturedImage').parent().addClass('dd-has-video');
            $('#galleryModalFeaturedImage #dd-m-gallery__video').data('data-plyr-embed-id', $el.data('video'));

            const div = $('<div id="dd-player-modal" data-plyr-provider="youtube" data-plyr-embed-id="' + $el.data('video') + '"/>');
            $('#ddGalleryFeatModal').append(div);
            const player = new Plyr('#dd-player-modal');
        }

        $('#galleryModalFeaturedImage .dd-desktop').attr('srcset', imgDesktop);
        $('#galleryModalFeaturedImage .dd-tablet').attr('srcset', imgTablet);
        $('#galleryModalFeaturedImage .dd-mobile').attr('srcset', imgMobile);
    });

    $('.dd-m-gallery__expand-btn').on('click', () => {
        $('.dd-m-modal--gallery').addClass('open');
        $('body').addClass('menu-mode');
        disableBodyScroll(bodyElement);
        $('.dd-m-modal--gallery').css('display', 'flex')
            .hide()
            .fadeIn('fast');

        setTimeout(() => {
            slider2 = $('.dd-carousel--custom-gallery').slick(slickOptions.getSimpleGallery());
            slider2.init(() => slider2.css('visibility', 'visible'));
        }, 200);
    });

    $('.dd-m-modal--gallery__close-btn').on('click', (e) => {
        $(e.currentTarget).closest('.dd-m-modal').fadeOut('fast');
        $('.dd-m-modal--gallery').removeClass('open');
        $('body').removeClass('menu-mode');
        enableBodyScroll(bodyElement);
        resetSlider2();
    });


    // Inicia videos da galeria no mobile
    $.each($('.dd-gallery-video'), (index, element) => {
        const player = new Plyr(element);
        players.push(player);
    });

    // Click outside
    $(document).mouseup(function (e) {
        const popup = $(".dd-m-modal__content");
        if (!popup.is(e.target) && popup.has(e.target).length == 0 && $('.dd-m-modal--gallery').hasClass('open')) {
            $('.dd-m-modal').fadeOut('fast');
            $('.dd-m-modal--gallery').removeClass('open');
            $('body').removeClass('menu-mode');
            enableBodyScroll(bodyElement);
            resetSlider2();
        }
    });

}



// WEBPACK FOOTER //
// ./resources/site/js/components/product.js